import { createSlice } from '@reduxjs/toolkit';

import type { TLiquiditySourceSource } from '../../types/liquiditySource';

const initialState: TLiquiditySourceSource | '' = '';

const liquiditySourceSlice = createSlice({
  name: 'liquiditySource',
  reducers: {},
  initialState,
});

export const liquiditySourceReducer = liquiditySourceSlice.reducer;
